import { Observable } from 'rxjs';
import { Global } from 'src/app/Service/global.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { sp, SPHttpClient } from "@pnp/sp";

@Injectable({
  providedIn: 'root'
})
export class TarifPublicService {

  constructor(private http:HttpClient,private global:Global) { }

  httpOptions = {
    headers: new HttpHeaders({
        "Content-Type": "text/xml; charset=utf-8",
        dataType: "xml"
    })
  };


  getTarif(url , listname){
    return this.http.get(url+"/_api/web/lists/GetByTitle('"+ listname+"')/items?"
    +"$select=*&$top=4000",this.httpOptions);
  }

}
